/* eslint-disable prettier/prettier */
import {
	Table as ReactTable,
	useReactTable,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	flexRender,
} from '@tanstack/react-table'
import Pagination from 'components/Pagination'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'

function Table({
	data,
	columns,
	totalCount,
	onChangePage,
	onChangePageSize,
	pageIndex = 0,
	friendTable,
	rankTable,
	friendTableMobile,
	setParamGetRank = () => { },
	paramGetRank = {},
}) {
	const { t } = useTranslation()

	const table = useReactTable({
		data,
		columns,
		// Pipeline
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		//
		debugTable: true,
	})
	const width = rankTable && columns.length === 3 ? '33.33' : "auto"

	const { pageSize } = table.getState().pagination
	const totalRoomList = totalCount ? totalCount : table.options.data?.length
	return (
		<div
			style={{ height: '100%' }}
			className={`roompage-table ${friendTable ? 'friend-table' : ''} ${rankTable ? 'rank-table' : ''
				} ${friendTableMobile ? 'friend-table-mobile' : ''} mt-2 mt-md-3`}
		>
			<table>
				<thead>
					{table.getHeaderGroups().map(headerGroup => (
						<tr key={headerGroup.id}>
							{headerGroup.headers.map(header => {
								return (
									<th key={header.id} width={`${width}%`}>
										{header.isPlaceholder ? null : (
											<div>
												{flexRender(
													header.column.columnDef.header,
													header.getContext(),
												)}
											</div>
										)}
									</th>
								)
							})}
						</tr>
					))}
				</thead>
				<tbody>
					{table.getRowModel().rows.length ? table.getRowModel().rows.map(row => {
						return (
							<tr key={row.id} className={`${row.original.is_rank_current ? "current-row" : ""}`}>
								{row.getVisibleCells().map(cell => {
									return (
										<td key={cell.id}>
											{flexRender(
												cell.column.columnDef.cell,
												cell.getContext(),
											)}
										</td>
									)
								})}
							</tr>
						)
					}) :
						<tr>
							<td colSpan={60} style={{ height: '500px' }}>
								<img
									style={{ width: '20%', margin: 'auto' }}
									src={noDataIcon}
									alt="No reward is found"
								/>
							</td>
						</tr>
					}
				</tbody>
			</table>
			<div className="d-flex justify-content-between align-items-center mt-3">
				<div className="pagination-pagesize d-flex">
					<select
						value={pageSize}
						onChange={e => {
							if (onChangePageSize instanceof Function)
								onChangePageSize(Number(e.target.value))
							table.setPageSize(Number(e.target.value))
							setParamGetRank({ ...paramGetRank, limit: e.target.value })
						}}
					>
						{[10, 20, 30, 40, 50].map(pageSize => (
							<option key={pageSize} value={pageSize}>
								{pageSize}
							</option>
						))}
					</select>
					<span>
						<div>
							{t('room.table.pagination')
								.replace('_FIRSTROOM_', `${pageIndex * pageSize + 1}`)
								.replace(
									'_LASTROOM_',
									`${totalRoomList >= pageIndex * pageSize + pageSize
										? pageIndex * pageSize + pageSize
										: totalRoomList % ((pageIndex + 1) * pageSize)
									}`,
								)
								.replace('_TOTALROOM_', `${totalRoomList}`)}
						</div>
					</span>
				</div>
				<Pagination
					className="pagination-bar"
					currentPage={pageIndex}
					totalCount={totalRoomList}
					pageSize={pageSize}
					table={table}
					onChangePage={onChangePage}
				/>
			</div>
		</div>
	)
}

export default Table
